<template>
  <div class="ffa-welcome-page login-background">
    <div class="ffa-welcome-content">
      <div class="welcome-top">
        <div class="brand-logo">
          <BaseSpriteIcon
            view-box="0 0 24 24"
            custom-class="ico-logo"
            icon-name="ico-logo-ffa"
          />
          <BaseSpriteIcon
            viewBox="0 0 160 21"
            custom-class="ico-logo-name"
            icon-name="pic-app-name-ffa"
          />
        </div>

        <div class="welcome-title">
          Meet WholeReader, <br />
          an <span>immersive reading</span><br />
          app for all ages
        </div>
      </div>
      <div class="welcome-pic-wrapper">
        <img :src="welcomePic" alt="header-pic-bg" />
      </div>
      <div class="welcome-bottom">
        Trying to join WholeReader? You can`t sign up for WholeReader in the
        app. We know it`s hassle. After you are a member, you can start reading
        and listening to books in the app.
      </div>
    </div>
    <div class="welcome-buttons">
      <SingInControl
        color="primary"
        :large="$vuetify.breakpoint.smAndDown"
        :xx-large="$vuetify.breakpoint.mdAndUp"
        block
        elevation="0"
      />
    </div>
  </div>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import SingInControl from '@/components/controls/SingInControl/SingInControl';
import images from '@/assets/images';

export default {
  components: {
    BaseSpriteIcon,
    SingInControl
  },
  data() {
    return {
      header: {
        productName: this.$t('ProductName'),
        titleText: this.$t('App.Login.header.titleText'),
        icon: 'ico-logo-ffa'
      },
      intro: {
        titleText: this.$t('App.Login.intro.title'),
        descriptionText: this.$t('App.Login.intro.text'),
        picture: 'pic-logo'
      },
      paidOnlyIntro: {
        titleText: this.$t('App.Login.paidOnlyIntro.title'),
        descriptionText: this.$t('App.Login.paidOnlyIntro.text')
      },
      welcomePic: images.headerPic1
    };
  }
};
</script>

<style lang="less" src="./BaseDeviceLoginPage.less"></style>
